import { JsonSchemaObject } from '../types'

export const parseDefault = (_schema: JsonSchemaObject) => {
  return 'z.any()'
}
